import { useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import { useFilter } from "../../../context/FIlterContext";
import { useCommon } from "../../Common/useCommon";
import _ from "underscore";

export const useProjectDashboard = () => {
    const [options, setOptions] = useState(null);
    const { projectFilter, setProjectFilter } = useFilter();
    const { projectOpts, getUserProjects } = useCommon();
    const [commonApi, setCommonApi] = useState(false);
    const tagRef = useRef();

    useEffect(() => {
        callautopopulate("users", "project_leads", "client", "user_info").then((res) => {
            const userOption = res?.users
                ?.map((user) => ({
                    label: user.user_display_name,
                    value: user.user_code,
                }))
                .sort((a, b) => a.label?.localeCompare(b.label));
            setOptions({ userOptions: userOption, leadOptions: res?.project_leads, clientOptions: _.sortBy(res?.client, "client_name"),})
            const data = _.findWhere(res?.project_leads, { user_code: res?.user_info?.[0]?.user_code });
            setProjectFilter((prev) => ({ ...prev, lead_user_code: data, apiCall: true }));
            getUserProjects();
        }).catch((err) => {
            setProjectFilter((prev) => ({ ...prev, apiCall: true }));
            console.error(err)
        });
        // eslint-disable-next-line
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if ((name === "request_user_code" || name === "client_id" || name === "lead_user_code") && value === undefined) {
            setProjectFilter((prev) => ({ ...prev, [name]: null, flag: true }))
            setCommonApi(true)
        } else if (name === "project_ids") {
            setProjectFilter((prev) => ({ ...prev, [name]: value, isProjectChange: false, flag: true }))
        } else {
            setProjectFilter((prev) => ({ ...prev, [name]: value, flag: true }))
        }
    }

    const handleAPICall = (key) => {
        if (key === "project_name") {
            projectFilter?.flag && setProjectFilter((prev) => ({ ...prev, isProjectChange: true }))
        }

        if (key !== "project_name" && projectFilter?.flag || commonApi) {
            setProjectFilter((prev) => ({ ...prev, flag: false, apiCall: true }))
            setCommonApi(false)
        }
    }

    const handleClear = (key, name) => {
        if (name === "project_name") {
            setProjectFilter((prev) => ({ ...prev, isProjectChange: true }))
        }
        setProjectFilter((prev) => ({ ...prev, [name]: [], flag: true }))
    }

    const getSelectedValues = async (key, value) => {
        if (key === "reset" && value === "project_module") {
            setProjectFilter((prev) => ({ ...prev, project_module_ids: [], flag: true }))
        } else if (key === "reset" && value === "epic") {
            setProjectFilter((prev) => ({ ...prev, feature_ids: [], flag: true }))
        } else if (key === "epic") {
            setProjectFilter((prev) => ({ ...prev, feature_ids: value, flag: true }))
        } else if (key === "project_module") {
            setProjectFilter((prev) => ({ ...prev, project_module_ids: value, flag: true }))
        }
        await setCommonApi(true)
    }

    let tempData = {}
    const handleEmpty = (key, value) => {
        if (key === "epic") {
            setProjectFilter((prev) => ({ ...prev, feature_ids: value, flag: false }))
        } else if (key === "project_module") {
            setProjectFilter((prev) => ({ ...prev, project_module_ids: value, flag: false }))
        }
        tempData[key] = 'is_called';
        if (tempData?.project_module && tempData?.epic) {

            setProjectFilter((prev) => ({ ...prev, isProjectChange: false }))
            setCommonApi(true)
            tempData = {}
        }

    }

    useEffect(() => {
        if (commonApi) {
            handleAPICall("other")
        }
    }, [commonApi])


    return useMemo(() => ({
        options, projectFilter, setProjectFilter, handleChange, projectOpts, handleAPICall, handleClear, getSelectedValues, handleEmpty, tagRef
    }), [options, projectFilter, setProjectFilter, handleChange, projectOpts, handleAPICall, handleClear, getSelectedValues, handleEmpty, tagRef])

}